import { Pipe, PipeTransform } from '@angular/core';
import { SalesBid } from '@generated/models';

@Pipe({
  name: 'bidLink',
})
export class BidLinkPipe implements PipeTransform {
  transform(value: { id: string }, ...args: string[]): string[] {
    return bidLink(value, args);
  }
}
export const bidLink = (bid: Pick<SalesBid, 'id'>, childRoutes: string[] = []): string[] => {
  return ['/', 'biddings', 'bids', bid.id, ...childRoutes];
};
